
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../base/LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation('common');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
      
      // Vérifier si on a atteint la section services
      const servicesSection = document.getElementById('services');
      if (servicesSection) {
        const servicesSectionTop = servicesSection.offsetTop;
        setIsHidden(scrollTop >= servicesSectionTop - 100);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-transparent transition-all duration-500 ${
      isHidden ? 'opacity-0 pointer-events-none -translate-y-full' : 'opacity-100 translate-y-0'
    }`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/15c1abdb2e0285c3498cde5ccf72ca8b.png" 
              alt="HAFY TOURS Logo" 
              className={`w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-56 lg:h-56 object-contain transition-all duration-300 ${
                isScrolled ? 'brightness-0 saturate-100' : 'bg-transparent'
              }`}
              style={{ 
                backgroundColor: 'transparent',
                filter: isScrolled ? 'brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(1352%) hue-rotate(204deg) brightness(95%) contrast(101%)' : 'none'
              }}
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <a href="#accueil" className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}>{t('home')}</a>
            <a href="#services" className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}>{t('services')}</a>
            <a href="#a-propos" className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}>{t('about')}</a>
            <a href="#galerie" className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}>{t('gallery')}</a>
            <a href="#contact" className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}>{t('contact')}</a>
            <a href="#reservation" className="bg-gold-500 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-gold-600 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm xl:text-base">{t('reserve')}</a>
            <LanguageSwitcher />
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center space-x-3 sm:space-x-4">
            <LanguageSwitcher />
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className={`lg:hidden mt-4 pb-4 border-t ${
            isScrolled ? 'border-gray-100' : 'border-white/20'
          }`}>
            <div className="flex flex-col space-y-3 sm:space-y-4 pt-4">
              <a href="#accueil" onClick={() => setIsMobileMenuOpen(false)} className={`hover:text-gold-400 transition-colors font-medium text-left whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>{t('home')}</a>
              <a href="#services" onClick={() => setIsMobileMenuOpen(false)} className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>{t('services')}</a>
              <a href="#a-propos" onClick={() => setIsMobileMenuOpen(false)} className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>{t('about')}</a>
              <a href="#galerie" onClick={() => setIsMobileMenuOpen(false)} className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>{t('gallery')}</a>
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className={`hover:text-gold-400 transition-colors font-medium whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>{t('contact')}</a>
              <a href="#reservation" onClick={() => setIsMobileMenuOpen(false)} className="bg-gold-500 text-white px-6 py-2 rounded-full hover:bg-gold-600 transition-colors font-medium text-center whitespace-nowrap cursor-pointer">{t('reserve')}</a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
